// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

.VisualUpload .resolution-error {
  margin-top: 8px;
  color: #E02D4F;
}
.VisualUpload .UploadDropzone {
  text-align: left;
}
.VisualUpload .UploadDropzone .dropzone {
  border: none;
  height: 98px !important;
}
.VisualUpload .upload-main {
  width: 100%;
}
.VisualUpload .upload-main.error .uploaded-content {
  border: 1px dashed #E02D4F;
}
.VisualUpload .uploaded-container {
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
}
.VisualUpload .uploaded-container .uploaded-content {
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  width: 100%;
  border: 1px solid var(--Gray-200, #EAECF0);
  background: var(--Base-White, #FFF);
  min-height: 64px;
}
.VisualUpload .uploaded-container .uploaded-content .uploaded-image {
  height: 64px;
}
.VisualUpload .uploaded-container .uploaded-content .upload-data {
  display: block;
  margin-left: 8px;
  width: 100%;
}
.VisualUpload .uploaded-container .uploaded-content .upload-data .ProgressBar {
  margin-top: 6px;
  border-radius: 4px;
  width: 86%;
}
.VisualUpload .uploaded-container .uploaded-content .upload-data .ProgressBar .slider-track,
.VisualUpload .uploaded-container .uploaded-content .upload-data .ProgressBar .slider-thumb {
  background: #FECF0C;
}
.VisualUpload .uploaded-container .uploaded-content .upload-data .ProgressBar .slider-rail {
  background: #EAECF0;
}
.VisualUpload .uploaded-container .uploaded-content .upload-data .upload-progress {
  opacity: 1;
  transition: opacity 3s;
}
.VisualUpload .uploaded-container .uploaded-content .upload-data .upload-progress.fadeOut {
  opacity: 0;
}
.VisualUpload .uploaded-container .uploaded-content .upload-data .progress-bar-label {
  display: inline-block;
  margin-left: 6px;
  opacity: 1;
  transition: opacity 3s;
}
.VisualUpload .uploaded-container .uploaded-content .upload-data .progress-bar-label.fadeOut {
  opacity: 0;
}
.VisualUpload .uploaded-container .uploaded-content .upload-data .upload-name {
  color: var(--Gray-500, #667085);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.VisualUpload .uploaded-container .uploaded-content .upload-data .upload-name span.filename {
  vertical-align: top;
  line-height: 18px;
  margin-left: 4px;
}
.VisualUpload .uploaded-container .uploaded-content .upload-data .uploaded-stats {
  color: var(--Gray-500, #667085);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.VisualUpload .uploaded-container .upload-replace {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: var(--Gray-500, #667085);
}
.VisualUpload .upload-container {
  display: flex;
  padding: 16px 24px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px dashed var(--Gray-200, #EAECF0);
  background: var(--Gray-50, #F9FAFB);
}
.VisualUpload .upload-container .upload-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
}
.VisualUpload .upload-container .upload-content .upload-icon {
  display: flex;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  background: var(--Gray-100, #F2F4F7);
}
.VisualUpload .upload-container .upload-content .drag-and-drop-text {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.VisualUpload .upload-container .upload-content .click-to-upload-text {
  color: var(--Gray-500, #667085);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/web/client/src/components/Messages/NewMessageRequest/Sidebar/Section/VisualUpload.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACIE;EACE,eAAA;EACA,cDEE;ACoFN;AAnFE;EACE,gBAAA;AAqFJ;AAlFE;EACE,YAAA;EACA,uBAAA;AAoFJ;AAjFE;EACE,WAAA;AAmFJ;AA9EI;EACI,0BAAA;AAgFR;AA5EE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA8EJ;AA5EI;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,mCAAA;EACA,gBAAA;AA8ER;AA5EQ;EACI,YAAA;AA8EZ;AA3EQ;EACI,cAAA;EACA,gBAAA;EACA,WAAA;AA6EZ;AA3EY;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AA6Ed;AA3Ec;;EAEE,mBDvDP;ACoIT;AA1Ec;EACE,mBDcN;AC8DV;AAxEY;EACE,UAAA;EACA,sBAAA;AA0Ed;AAvEY;EACE,UAAA;AAyEd;AAtEY;EACE,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,sBAAA;AAwEd;AArEY;EACE,UAAA;AAuEd;AApEY;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAsEhB;AApEgB;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;AAsEpB;AAlEY;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAoEhB;AA/DI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,+BAAA;AAiER;AA7DE;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mCAAA;AA+DJ;AA7DI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AA+DR;AA7DQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;AA+DZ;AA5DQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AA8DZ;AA3DQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA6DZ","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxPurple16: rgba($boxPurple, 0.16);\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n  boxPurple16: $boxPurple16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '~vibeguide/sass/color.scss' as color;\n\n.VisualUpload {\n\n  .resolution-error {\n    margin-top: 8px;\n    color: color.$red;\n  }\n\n  .UploadDropzone {\n    text-align: left;\n  }\n\n  .UploadDropzone .dropzone {\n    border: none;\n    height: 98px !important;\n  }\n\n  .upload-main {\n    width: 100%;\n  }\n\n  .upload-main.error {\n    \n    .uploaded-content {\n        border: 1px dashed color.$red;\n    }\n  }\n\n  .uploaded-container {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    align-self: stretch;\n\n    .uploaded-content {\n        display: flex;\n        padding: 16px;\n        align-items: center;\n        gap: 4px;\n        border-radius: 8px;\n        width: 100%;\n        border: 1px solid var(--Gray-200, #EAECF0);\n        background: var(--Base-White, #FFF);\n        min-height: 64px;\n\n        .uploaded-image {\n            height: 64px;\n        }\n\n        .upload-data {\n            display: block;\n            margin-left: 8px;\n            width: 100%;\n\n            .ProgressBar {\n              margin-top: 6px;\n              border-radius: 4px;\n              width: 86%;\n              \n              .slider-track,\n              .slider-thumb {\n                background: color.$yellow;\n              }\n\n              .slider-rail {\n                background: color.$gray200;\n              }\n            }\n\n            .upload-progress {\n              opacity: 1;\n              transition: opacity 3s;\n            }\n\n            .upload-progress.fadeOut {\n              opacity: 0;\n            }\n\n            .progress-bar-label {\n              display: inline-block;\n              margin-left: 6px;\n              opacity: 1;\n              transition: opacity 3s;\n            }\n\n            .progress-bar-label.fadeOut {\n              opacity: 0;\n            }\n\n            .upload-name {\n                color: var(--Gray-500, #667085);\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 20px;\n\n                span.filename {\n                    vertical-align: top;\n                    line-height: 18px;\n                    margin-left: 4px;\n                }\n            }\n    \n            .uploaded-stats {\n                color: var(--Gray-500, #667085);\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 20px;\n            }\n        }\n    }\n\n    .upload-replace {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n        color: var(--Gray-500, #667085);\n    }\n  }\n\n  .upload-container {\n    display: flex;\n    padding: 16px 24px;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n    border-radius: 4px;\n    border: 1px dashed var(--Gray-200, #EAECF0);\n    background: var(--Gray-50, #F9FAFB);\n\n    .upload-content {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 4px;\n        align-self: stretch;\n\n        .upload-icon {\n            display: flex;\n            width: 36px;\n            height: 36px;\n            justify-content: center;\n            align-items: center;\n            border-radius: 28px;\n            background: var(--Gray-100, #F2F4F7);\n        }\n    \n        .drag-and-drop-text {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            gap: 8px;\n        }\n    \n        .click-to-upload-text {\n            color: var(--Gray-500, #667085);\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 20px;\n        }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxPurple16 = `rgba(109, 109, 181, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
